exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden {\n  display: none;\n}\n\n.menuItemDropDown.open .dropdown-menu {\n  width: calc(100% - 30px);\n  margin-left: 15px;\n  margin-bottom: 50px;\n  margin-top: -3px;\n}\n\n.drop-menufull label {\n  margin: 0;\n}\n\n.all-checkbox {\n  padding-top: 20px;\n}\n\n.drop-btn-group h4 {\n  position: relative;\n}\n\n.drop-btn-group h4::after {\n  display: block;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-left: 0.3em solid transparent;\n  position: absolute;\n  top: 25px;\n  right: 20px;\n}\n\n.checkbox-fade{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.description-bg {\n  background: #f0f0f0;\n  padding: 15px;\n}\n\n.description-gb {\n  background: #ffffff;\n  padding: 15px;\n}\n\n.customAccordion img {\n  max-height: 200px;\n  display: block;\n  margin: 20px auto;\n}\n\n.sebm-google-map-container {\n  width: 100%;\n  height: 250px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/event/sessions-add/sessions-add.component.css
// module id = ../../../../../src/app/event/sessions-add/sessions-add.component.css
// module chunks = main